import React from "react";
import Controls from "../../../components/controls/control";
import FormLabel from "../../../components/HtmlMarkup/FormLabel";

export default function QuizzesOption({ values, handleInputChange }) {
  return (
    <>
      {/* Option 1 */}
      <div className="fieldContainer">
        <FormLabel htmlFor={"option-one"}>Option One</FormLabel>
        <Controls.Input
          id="option-one"
          name="optionOne"
          autocomplete="option-one"
          className="login-input rounded-t-md"
          placeholder="Enter quizze option-one"
          value={values.optionOne}
          onChange={handleInputChange}
        />
      </div>
      <div className="fieldContainer">
        <FormLabel htmlFor={"isCorrect-option-one"}>
          Option one is correct ?
        </FormLabel>
        <Controls.Input
          id="isCorrect-option-one"
          name="isCorrectOptionOne"
          autocomplete="isCorrectOptionOne"
          className="login-input rounded-t-md"
          type="checkbox"
          required={false}
          checked={values.isCorrectOptionOne}
          onChange={handleInputChange}
        />
      </div>
      {/* Option 2 */}
      <div className="fieldContainer">
        <FormLabel htmlFor={"option-one"}>Option Two</FormLabel>
        <Controls.Input
          id="option-two"
          name="optionTwo"
          autocomplete="option-two"
          className="login-input rounded-t-md"
          placeholder="Enter quiz option-two"
          value={values.optionTwo}
          onChange={handleInputChange}
        />
      </div>
      <div className="fieldContainer">
        <FormLabel htmlFor={"isCorrect-option-two"}>
          Option two is correct ?
        </FormLabel>
        <Controls.Input
          id="isCorrect-option-two"
          name="isCorrectOptionTwo"
          autocomplete="isCorrectOptionTwo"
          className="login-input rounded-t-md"
          type="checkbox"
          required={false}
          checked={values.isCorrectOptionTwo}
          onChange={handleInputChange}
        />
      </div>
      {/* Option 3 */}
      <div className="fieldContainer">
        <FormLabel htmlFor={"option-three"}>Option Three </FormLabel>
        <Controls.Input
          id="option-three"
          name="optionThree"
          autocomplete="option-three"
          className="login-input rounded-t-md"
          placeholder="Enter quizze option-three"
          value={values.optionThree}
          onChange={handleInputChange}
        />
      </div>
      <div className="fieldContainer">
        <FormLabel htmlFor={"isCorrect-option-three"}>
          Option three is correct ?
        </FormLabel>
        <Controls.Input
          id="isCorrect-option-three"
          name="isCorrectOptionThree"
          autocomplete="isCorrectOptionThree"
          className="login-input rounded-t-md"
          type="checkbox"
          required={false}
          checked={values.isCorrectOptionThree}
          onChange={handleInputChange}
        />
      </div>
      {/* Option 4 */}
      <div className="fieldContainer">
        <FormLabel htmlFor={"option-one"}>Option Four</FormLabel>
        <Controls.Input
          id="option-four"
          name="optionFour"
          autocomplete="option-four"
          className="login-input rounded-t-md"
          placeholder="Enter quizze option-four"
          value={values.optionFour}
          onChange={handleInputChange}
        />
      </div>
      <div className="fieldContainer">
        <FormLabel htmlFor={"isCorrect-option-four"}>
          Option four is correct ?
        </FormLabel>
        <Controls.Input
          id="isCorrect-option-four"
          name="isCorrectOptionFour"
          autocomplete="isCorrectOptionFour"
          className="login-input rounded-t-md"
          type="checkbox"
          required={false}
          checked={values.isCorrectOptionFour}
          onChange={handleInputChange}
        />
      </div>
    </>
  );
}
